var React = require('react');

function Eject (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 384v64a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M259.38 47.56l175.94 192c28.2 30.77 6.27 80.44-35.38 80.44H48.05c-41.73 0-63.52-49.73-35.38-80.44l176-192a48 48 0 0 1 70.71 0z","className":"fa-primary","key":2})]);
}

Eject.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Eject;

Eject.default = Eject;
